module.exports = __webpack_public_path__ + "img/step2.4fe42cd1.png";